export default {
  middleware_url: "https://wip.secib.fluid-it.fr",
  cake_url: "https://wip.cake.secib.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  billingConforamaEnabled: false,
};
